import type { DashboardCardFilters } from '../types'
import {
    parseAlphaNumericField,
    parseHasWords,
    parseLowHighOperatorField,
    parseNotOperatorField,
    parseNumberOperatorField,
    parseOdometer,
    parseRepField,
    parseYear,
} from './fields'

/** Convert AQL string to DashboardFilters  */
export const convertAQLToDashboardCardFilters = (aql?: string): DashboardCardFilters => {
    if (!aql) {
        return { vehicle: {}, sale: {}, company: {}, contact: {} }
    }

    const vehicle = {
        ...parseAlphaNumericField(aql, 'make'),
        ...parseAlphaNumericField(aql, 'model'),
        ...parseAlphaNumericField(aql, 'color'),
        ...parseNumberOperatorField(aql, 'checkIn'),
        ...parseYear(aql),
        ...parseOdometer(aql),
        ...parseLowHighOperatorField(aql, 'photos'),
        ...parseAlphaNumericField(aql, 'hasCr'),
        ...parseAlphaNumericField(aql, 'hasTitle'),
    }

    const sale = {
        ...parseAlphaNumericField(aql, 'saleStatus'),
        ...parseNumberOperatorField(aql, 'saleDate'),
        ...parseAlphaNumericField(aql, 'lane'),
        ...parseAlphaNumericField(aql, 'run'),
        ...parseLowHighOperatorField(aql, 'ranCount'),
        ...parseLowHighOperatorField(aql, 'lot'),
        ...parseLowHighOperatorField(aql, 'floor'),
        ...parseLowHighOperatorField(aql, 'mmr'),
        ...parseLowHighOperatorField(aql, 'blackbook'),
    }

    const company = {
        ...parseAlphaNumericField(aql, 'seller'),
        ...parseNotOperatorField(aql, 'sellerId'),
        ...parseNotOperatorField(aql, 'sellerType'),
        ...parseAlphaNumericField(aql, 'buyer'),
        ...parseNotOperatorField(aql, 'buyerId'),
        ...parseNotOperatorField(aql, 'buyerType'),
        ...parseRepField(aql),
        ...parseAlphaNumericField(aql, 'isFavorite'),
    }

    const contact = {
        ...parseAlphaNumericField(aql, 'contactStatus'),
        ...parseAlphaNumericField(aql, 'contactMethod'),
        ...parseAlphaNumericField(aql, 'creatorFullName'),
        ...parseAlphaNumericField(aql, 'followupFullName'),
        ...parseAlphaNumericField(aql, 'completedFullName'),
        ...parseNumberOperatorField(aql, 'contactedAt'),
        ...parseNumberOperatorField(aql, 'followupAt'),
        ...parseNumberOperatorField(aql, 'completedAt'),
    }

    const { hasWords } = parseHasWords(aql)

    const filters = {
        vehicle,
        sale,
        company,
        contact,
        hasWords,
    }

    return filters
}

export default convertAQLToDashboardCardFilters
